import React from "react";
import { Link } from "react-router-dom";
import { StldCardAtividadesOptions } from "../../styled-components/StyledCardAtividadesOptions.style";
import Flex from '@react-css/flex';

export const CardAtividadesOptions = (props) => {
    const {
        item,
        index,
        openObservacoesTimesheet,
        openModalASolicitarEsclarecimento,
        openModalTimesheetTimeline
    } = props;

    let dadosUsuario = JSON.parse(localStorage.getItem("PROFILE_DATA_SISCOPE"));
    return (
        <StldCardAtividadesOptions className={'Reanálise' === item.statusTimesheet ? 'revisaoCard' : item?.pendenteDeEsclarecimento ? 'esclarecimentoCard' : (item?.actions?.notificacaoAtividade || item?.actions?.notificacaoGrupoAtividade) ? 'notificacaoCard' : (item?.atividadesProbono > 0 ? 'probonoCard' : '')}>
            <div className="card-align" key={index}>
                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text-bold">{item.timeSheetSigla} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right header-items">
                        <span className="legend-title-text"><span className="badge bg-lightblue" >{item.vidaUtil}</span> </span>
                        <a className="menu-link hover">
                            <i className="fa fa-calendar" onClick={() => openModalTimesheetTimeline(item)}></i>
                        </a>
                        {
                            item?.actions?.notificacaoEsclarecimento && (
                                <a className="menu-link hover" onClick={() => openModalASolicitarEsclarecimento(item)} title="Esclarecimento">
                                    <i className={item.pendenteDeEsclarecimento ? (item.idusuarioUltimaMsgEscalrecimento == dadosUsuario.idUsuario ? "fa fa-list-ol possui-comentarios" : "fa fa-list-ol possui-comentarios resposta-pendente") : "fa fa-list-ol"}></i>
                                </a>
                            )
                        }

                        <a className="menu-link hover" onClick={() => openObservacoesTimesheet(item.idTimesheet)} title="Observação">
                            <i className={item.quantidadeComentarios > 0 ? "fa fa-comments-o possui-comentarios" : "fa fa-comments-o"}></i>
                        </a>
                        <Link className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: item.idTimesheet }} title="Detalhes do Timesheet">
                            <i className="fa fa-search fa-rotate-90"></i>
                        </Link>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="flex-title-full">
                        <span className="legend-title-text-bold"> {item.tipoTimesheet} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-time">
                            {item.dataTimesheet}
                        </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text"> {item.sigla} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-title-text-1"> {item.statusTimesheet} </span>
                    </Flex.Item>
                </Flex>
                <Flex className="flex-workflow-right">
                    <Flex.Item className="flex-column-right-100">
                        <span className="legend-title-text-2"> ({item.workflow})</span>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="flex-column-left text-max-35">
                        <span className="legend-title-text-bold-1 " title={item.cliente.clienteNome}> {item.cliente.clienteNome}</span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-35">
                        <span className="legend-title-text-bold-1" title={item.segurado.seguradoNome}> {item.segurado.seguradoNome}</span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left-20">
                        <span className="legend-time">{item.horasTimeSheet}</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right-80">
                        <span className="legend-value"> {item.valorTotalDesconto > 0 ? "*" : ""} {item.valorTimesheet} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="footer-details"> Horas Lançadas </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="footer-details"> valor total </span>
                    </Flex.Item>
                </Flex>

                {/* <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="footer-details-bold"> {item.estimativaPericia} estimativa </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-center">
                        <span className="footer-details-bold"> {item.executadoPericia} executado </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="footer-details-bold"> {item.saldoPericia} saldo </span>
                    </Flex.Item>
                </Flex> */}

                <Flex>
                    <Flex.Item className="flex-column-footer-1">
                        <span className="footer-details d-lg-none d-xl-block"> {item.quantidadeAtividades} atividades</span>
                        <span className="footer-details d-none d-lg-block d-xl-none"> {item.quantidadeAtividades} atividades</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-footer-2">
                        <span className="footer-details d-lg-none d-xl-block" > {item.quantidadeGrupo} atividades de grupo</span>
                        <span className="footer-details d-none d-lg-block d-xl-none" > {item.quantidadeGrupo} ativ... de grupo</span>
                    </Flex.Item>
                </Flex>
            </div>
        </StldCardAtividadesOptions>
    );
};
